export const multiMint = {
  scan: 'https://etherscan.io/address/0x71664391476F32CD98cfd07230B4F00A0a2Dc19C',
  markets: {
    openseaCreator: 'https://opensea.io/FacingTheSky/created',
    proOpensea:
      'https://pro.opensea.io/profile/0x71664391476f32cd98cfd07230b4f00a0a2dc19c',
    blur: 'https://blur.io/0x71664391476f32cd98cfd07230b4f00a0a2dc19c',
    looksrare:
      'https://looksrare.org/collections/0x71664391476F32CD98cfd07230B4F00A0a2Dc19C',
  },

  addr: '0x71664391476F32CD98cfd07230B4F00A0a2Dc19C',
  abi: [
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_devPer',
          type: 'uint256',
        },
        {
          internalType: 'address',
          name: '_dev',
          type: 'address',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'owner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'approved',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'Approval',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'owner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'operator',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'bool',
          name: 'approved',
          type: 'bool',
        },
      ],
      name: 'ApprovalForAll',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'Transfer',
      type: 'event',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'approve',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'owner',
          type: 'address',
        },
      ],
      name: 'balanceOf',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'getApproved',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'getAvailableTokens',
      outputs: [
        {
          internalType: 'uint8[]',
          name: '',
          type: 'uint8[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'owner',
          type: 'address',
        },
        {
          internalType: 'address',
          name: 'operator',
          type: 'address',
        },
      ],
      name: 'isApprovedForAll',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint8',
          name: 'tokenId',
          type: 'uint8',
        },
      ],
      name: 'isTokenAvailable',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint8[]',
          name: 'tokenIds',
          type: 'uint8[]',
        },
      ],
      name: 'mintList',
      outputs: [],
      stateMutability: 'payable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'name',
      outputs: [
        {
          internalType: 'string',
          name: '',
          type: 'string',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'ownerOf',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'paused',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'price',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'safeTransferFrom',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
        {
          internalType: 'bytes',
          name: 'data',
          type: 'bytes',
        },
      ],
      name: 'safeTransferFrom',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'operator',
          type: 'address',
        },
        {
          internalType: 'bool',
          name: 'approved',
          type: 'bool',
        },
      ],
      name: 'setApprovalForAll',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'string',
          name: '_url',
          type: 'string',
        },
      ],
      name: 'setBaseURI',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newDev',
          type: 'address',
        },
      ],
      name: 'setNewDevAddr',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'setPause',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_weiPrice',
          type: 'uint256',
        },
      ],
      name: 'setPrice',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'supply',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'bytes4',
          name: 'interfaceId',
          type: 'bytes4',
        },
      ],
      name: 'supportsInterface',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'symbol',
      outputs: [
        {
          internalType: 'string',
          name: '',
          type: 'string',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'tokenURI',
      outputs: [
        {
          internalType: 'string',
          name: '',
          type: 'string',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_owner',
          type: 'address',
        },
      ],
      name: 'tokensOfAddress',
      outputs: [
        {
          internalType: 'uint8[]',
          name: '',
          type: 'uint8[]',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'tokenId',
          type: 'uint256',
        },
      ],
      name: 'transferFrom',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'withdraw',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ],
  bytecode:
    '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',
};
